import { render, staticRenderFns } from "./AppButtonSmExport.vue?vue&type=template&id=084ff202&scoped=true&"
import script from "./AppButtonSmExport.vue?vue&type=script&lang=js&"
export * from "./AppButtonSmExport.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonSmExport.vue?vue&type=style&index=0&id=084ff202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ff202",
  null
  
)

export default component.exports